import React from 'react';
import { Skeleton } from 'primereact/skeleton';

export default function SkeletonCardLoading({ count = 5, parentClassName = '' }) {
  const skeletonConfig = [
    { width: '100%', height: '1rem' },
    { width: '50%', height: '1rem' },
    { width: '25%', height: '1rem' },
    { width: '100%', height: '2rem' },
    { width: '50%', height: '3rem' }
  ];

  return (
    <div className={`mt-4 ${parentClassName}`}>
      <div className='flex flex-wrap'>
        <div className='w-full p-3'>
          {Array.from({ length: count }).map((_, index) => {
            const { width, height } = skeletonConfig[index % skeletonConfig.length];
            return <Skeleton key={index} width={width} height={height} className='mb-2' />;
          })}
        </div>
      </div>
    </div>
  );
}
